export default __webpack_public_path__ + "static/media/psm-blue.5d93be8c.svg";